import axios from 'axios';

export default axios.create({
    baseURL: '/api',
    params: {
        // API params go here
    }
});